angular.module('impactx.util').directive('ixResizeable', ['$document', function ($document) {
    return {
        restrict: 'A',
        link: function (scope, element) {
            var resizeHandler = angular.element('<span id="resize-handler" class="mdi mdi-resize-bottom-right ix-resize-bottom-right"></span>');
            element.append(resizeHandler);

            var positionX, positionY;
            var elementWidth, elementHeight;
            resizeHandler.on('mousedown', function (event) {
                event.stopImmediatePropagation();
                positionX = event.clientX;
                positionY = event.clientY;

                elementWidth = element.prop('offsetWidth');
                elementHeight = element.prop('offsetHeight');

                $document.on('mousemove', function (event) {
                    var newWidth = elementWidth - (positionX - event.clientX);
                    var newHeight = elementHeight - (positionY - event.clientY);

                    element.css({
                        width: newWidth,
                        height: newHeight
                    });

                    return false;
                });

                $document.on('mouseup', function () {
                    $document.off('mousemove');
                    $document.off('mouseup');
                });
            });
        }
    }
}]);